/**
 * Provider RPC somente leitura (fonte única de URLs em config/rpcEndpoints).
 */
import { JsonRpcProvider } from 'ethers';
import { normalizeChainId } from '@/utils/networkSync';
import { getRpcUrls } from '@/config/rpcEndpoints';

const providerCache = new Map();
const DEFAULT_CHAIN = '0x1';

export { normalizeChainId };

export function getReadOnlyProvider(chainId) {
  const key = normalizeChainId(chainId) || DEFAULT_CHAIN;
  if (providerCache.has(key)) return providerCache.get(key);
  const urls = getRpcUrls(chainId, false);
  const url = urls?.[0];
  const provider = new JsonRpcProvider(url);
  providerCache.set(key, provider);
  return provider;
}
